<template slot-scope="scope">
  <!-- 企业钱包 表格组件（列表字段对齐后台企业钱包详情） -->
  <div class="device-list">
    <div class="device-list-tab">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#409eff ',
          textAlign: 'center',
          color: '#ffffff',
          padding: '3px',
          fontSize: '12px',
          fontWeight: '400',
          height: '45px',
        }"
        :row-style="{ height: '35px' }"
      >
        <el-table-column label="订单ID" align="center">
          <template slot-scope="scope">
            {{ scope.row.orderNumber }}
          </template>
        </el-table-column>
        <el-table-column
          label="金额(元)"
          align="center"
        >
          <template slot-scope="scope">
            {{
              Math.sign(scope.row.consumption) == 1
                ? "+" + scope.row.consumption
                : scope.row.consumption
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="侦迹币/发票豆"
          align="center"
        >
          <template slot-scope="scope">
            <span>
              {{
                Math.sign(scope.row.traceCoin) == 1
                  ? "+" + scope.row.traceCoin
                  : scope.row.traceCoin
              }}
              <span style="color: #999; margin-left: 2px">
                {{ isInvoiceBeanRow(scope.row) ? "发票豆" : "侦迹币" }}
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="消费类型" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.typeName }}
          </template>
        </el-table-column>
        <el-table-column label="消费内容" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.serviceContent }}
          </template>
        </el-table-column>
        <el-table-column
          label="支付方式"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.payMethodName }}
          </template>
        </el-table-column>
        <el-table-column
          label="时间"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {},
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    /**
     * 是否发票豆变动（与后台企业钱包详情一致）：
     * consumptionType=1 且 serviceType=-1
     * consumptionType=2 且 serviceType=0
     * consumptionType=5 且 serviceType=4/5/6
     */
    isInvoiceBeanRow(row) {
      if (!row) return false;
      const consumptionType = Number(row.consumptionType);
      const serviceType = Number(row.serviceType);
      if (consumptionType === 1 && serviceType === -1) return true;
      if (consumptionType === 2 && serviceType === 0) return true;
      if (consumptionType === 5 && [4, 5, 6].includes(serviceType)) return true;
      return false;
    },
    //表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "success-row";
    },
  },
};
</script>

<style scoped lang="less">
/deep/th:nth-child(1) {
  border-radius: 10px 0 0 0 !important;
}
/deep/th:nth-child(7) {
  border-radius: 0px 10px 0px 0px !important;
}

/deep/th {
  height: 45px !important;
  padding: 0;
}
/deep/ td {
  height: 40px !important;
  padding: 0;
}
.device-list-tab {
  border: 1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
}
/deep/.el-table__empty-block,
/deep/.el-table tr,
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  color: #333333;
  font-weight: 400;
  font-size: 12px;
}
/deep/.el-table .warning-row td {
  font-size: 12px;
  color: #333333;
}

::v-deep .el-table .warning-row td {
  background: #eeeeee !important;
}
</style>
